import {
  Box,
  Typography,
  useTheme,
  useMediaQuery,
  styled,
  CircularProgress,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useConfig } from '../../Hooks/useConfig';

const Layout = styled(Box)(({ theme, isInPanel }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  minHeight: '100vh',
  padding: !isInPanel ? theme.spacing(0, 6) : 0,
  background: '#fff',
}));

const Content = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  border: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.secondary.neutral_30 : theme.palette.secondary.neutral_90}`,
  width: theme.spacing(112),
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(4, 24),
  borderRadius: theme.spacing(3.75),
  // backgroundColor: 'lightpink',
  backgroundColor:
    theme.palette.mode === 'dark'
      ? theme.palette.secondary.surface_11
      : theme.palette.common.white,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(5, 6),
    border: `none`,
  },
}));

const PleaseWaitContent = styled(Box)(({ theme }) => ({
  // padding: '1rem',
  textAlign: 'center',
  borderRadius: theme.spacing(2),
  margin: 'auto',
  backgroundColor:
    theme.palette.mode === 'dark'
      ? theme.palette.common.surface_8
      : theme.palette.common.white,
  [theme.breakpoints.down('sm')]: {
    width: '95%',
  },
}));

// Rest of your styled components remain unchanged...

const StepperLoading = ({ verifiStatus, loading }) => {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));
  const { panelUrl, playgroundUrl } = useConfig();
  const { t } = useTranslation();

  const isInPanel = panelUrl.includes(window.location.hostname);

  return (
    <Layout isInPanel={isInPanel}>
      <Content>
        <PleaseWaitContent>
          <Typography
            sx={{
              fontSize: '20px !important',
              fontWeight: 500,
              mb: 4,
              color: '#000 !important',
            }}
          >
            {t('layout_playground.please_wait')}
          </Typography>
          <Typography
            sx={{
              color:
                theme.palette.mode === 'dark'
                  ? theme.palette.common.white
                  : '#5F5E62',
              mb: 4,
              lineHeight: 2.2,
            }}
          >
            {t('layout_playground.please_wait_text_first')} <br />{' '}
            {t('layout_playground.please_wait_text_second')}
          </Typography>
          <CircularProgress
            color={theme.palette.mode === 'dark' ? 'primary' : 'secondary'}
          />
        </PleaseWaitContent>
      </Content>
    </Layout>
  );
};

export default StepperLoading;
